<template>
  <span style="min-height: 3.2rem">
    <span
      data-narvar-feature="promiseEddCalculator"
      @click="$gtm.push('pdpPage.onEstimatedDeliveryDate')"
    />
    <span v-if="status !== 'loaded'" class="f-col gap-2">
      <span class="h-4 w-1/4 skeleton" />
      <span class="h-5 w-1/3 skeleton" />
    </span>
  </span>
</template>

<script lang="ts" setup>
import type { SelectedVariant } from '#types/product'

const { variant } = defineProps<{
  variant?: SelectedVariant
}>()

useHead({
  link: () => [
    {
      rel: 'stylesheet',
      type: 'text/css',
      href: '/narvar/css/NarvarEstimatedDelivery.css',
      once: true
    }
  ],
})

const auth = useAuthStore()
const xUsidCookie = useCookie('x-usid')
const localeCountry = useCountryCode()
const localeLanguage = useLanguageCode().toLowerCase()
const { $feature } = useNuxtApp()
const { onLoaded, remove, status } = useScript({
  src: $feature.configNarvarUrl,
  defer: true,
  crossorigin: false
})
const user = useUserStore()

const estimateDeliveryDate = async (variant?: SelectedVariant) => {
  await nextTick()

  window.narvar('promiseEddCalculator', {
    customerId: auth.consumerNo || xUsidCookie.value, // Authenticated user id or x-usid when unauthenticated
    localeLanguage,
    localeCountry,
    sessionId: xUsidCookie.value,
    platform: 'sfcc',
    store: location.origin,
    destZip: user.defaultShippingAddress?.postalCode,
    destCountry: user.defaultShippingAddress?.countryCode.toUpperCase(),
    itemSku: variant?.id,
    itemQuantity: 1,
    itemOriginalPriceAmount: variant?.price.current,
    itemOriginalPriceCurrency: useCurrencyCode(),
    itemInStock: variant?.buyable
  })
}

whenever(() => variant, () => estimateDeliveryDate(variant))
onLoaded(() => estimateDeliveryDate(variant))
onBeforeUnmount(() => remove())
</script>
